export default {
  user: {
    profile: '个人信息',
    identification: '身份认证',
    bankCard: '银行卡',
    deposit: '入金',
    withdraw: '出金',
  },
};
